"use strict";
export var UniswapEventName = /* @__PURE__ */ ((UniswapEventName2) => {
  UniswapEventName2["BalancesReport"] = "Balances Report";
  UniswapEventName2["BalancesReportPerChain"] = "Balances Report Per Chain";
  UniswapEventName2["TokenSelected"] = "Token Selected";
  UniswapEventName2["ConversionEventSubmitted"] = "Conversion Event Submitted";
  UniswapEventName2["BlockaidFeesMismatch"] = "Blockaid Fees Mismatch";
  UniswapEventName2["LowNetworkTokenInfoModalOpened"] = "Low Network Token Info Modal Opened";
  UniswapEventName2["LpIncentiveCollectRewardsButtonClicked"] = "LP Incentive Collect Rewards Button Clicked";
  UniswapEventName2["LpIncentiveCollectRewardsErrorThrown"] = "LP Incentive Collect Rewards Error Thrown";
  UniswapEventName2["LpIncentiveCollectRewardsRetry"] = "LP Incentive Collect Rewards Retry";
  UniswapEventName2["LpIncentiveCollectRewardsSuccess"] = "LP Incentive Collect Rewards Success";
  UniswapEventName2["LpIncentiveLearnMoreCtaClicked"] = "LP Incentive Learn More CTA Clicked";
  UniswapEventName2["SmartWalletMismatchDetected"] = "Smart Wallet Mismatch Detected";
  return UniswapEventName2;
})(UniswapEventName || {});
